import '../types/index.mjs';
import { StoreId } from '../types/generated.mjs';
"use strict";
const isStoreId = storeId => {
  return !!storeId && Object.values(StoreId).includes(storeId);
};
export { isStoreId };
//# sourceMappingURL=storeId.mjs.map
